import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import ReusableTable from '../../components/ReusableTable';
import { PencilFill, TrashFill, Download } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';

const MenuGroup = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    console.log("Email In Menu Group :", email);
    const [menuAccess, setMenuAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("MenuGroup:")
            );
            setMenuAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", menuAccess);
    

    const accessToken = localStorage.getItem('authToken');
    const [inputData, setInputData] = useState({
        groupName: '',
        description: ''
    });
    const [editData, setEditData] = useState({});
    const [menuGroupId, setMenuGroupId] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [errors, setErrors] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [productList, setProductList] = useState([]);

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        { header: "Created On", accessor: "createdAt",
            render: (value, row) => (
                <div>
                    <span className='text-muted'>
                        {new Date(row?.createdAt).toLocaleString('en-US', {
                            // weekday: 'short', // "Thu"
                            month: '2-digit',   // "Feb"
                            day: 'numeric',   // "6"
                            year: 'numeric',  // "2025"
                            // hour: 'numeric',  // "11"
                            // minute: 'numeric', // "01"
                            // hour12: true      // AM/PM
                        })}
                    </span>
                </div>
            )
        },
        { header: "Group Name", accessor: "groupName",
            render: (value, row) => (
                <div>
                    <span className='text-primary'>{row?.groupName}</span>
                </div>
            )
        },
        { header: "Default Group", accessor: "groupName",
            render: (value, row) => (
                <div>
                    <span className={row?.isDefaultGroup === true ? 'text-success' : 'text-danger'}>
                        {row?.isDefaultGroup ? 'YES' : 'NO'}
                    </span>
                </div>
            )
        },
        {
            header: "Description",
            accessor: "description",
            render: (value, row) => (
                <div className='text-start'>
                    <span className="mb-0">{row.description}</span>
                </div>
            ),
        },
        ...(
            (menuAccess?.includes("MenuGroup:update") || menuAccess?.includes("MenuGroup:delete") ||  email === "contact@xpansecafe.com")
                ? [
                    { header: <div className="text-center">Actions</div>, accessor: null, render: (_, row) => (
                        <div className="d-flex justify-content-center align-items-center">
                            {(menuAccess.includes("MenuGroup:update") || email === "contact@xpansecafe.com") && (
                                <Button
                                    variant="link"
                                    className="text-primary p-0 mx-2"
                                    onClick={() => handleOpenEditModal(row)}
                                    title="Edit"
                                >
                                    EDIT <PencilFill size={16} /> {/* React-Bootstrap Icon for Edit */}
                                </Button>
                            )}
                            {(menuAccess.includes("MenuGroup:delete") || email === "contact@xpansecafe.com") && (
                                <Button
                                    variant="link"
                                    className="text-danger p-0 mx-2"
                                    onClick={() => handleOpenDeleteModal(row)}
                                    title="Delete"
                                >
                                    DELETE <TrashFill size={16} /> {/* React-Bootstrap Icon for Delete */}
                                </Button>
                            )}
                        </div>
                        )
                    },
                ] : [] 
            )
        
    ];

    const getMenuGroup = async() => {
        setIsLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("menu-group", { headers });
            console.log("Response of group :", response);
        
            if (response?.data?.status === true) {
                response?.data?.data?.menuGroup.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });
        
                setGroupList(response?.data?.data?.menuGroup);
                setFilteredData(response?.data?.data?.menuGroup);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsLoading(false);
        }
    }

    const getProductsList = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                let filterPro = response?.data?.data?.products;
                console.log("log of filterPro:", filterPro);
            
                const simplifiedProducts = filterPro.map(product => ({
                    product: product._id,
                    mrp: product.mrp,
                    offerprice: product.offerPrice
                }));
            
                console.log("Simplified Product List:", simplifiedProducts);
                setProductList(filterPro); // You can also use setProductList(simplifiedProducts) if you only need the trimmed version
            }
            
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    // Download Menu Groups
    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const headers = { 
                Authorization: `Bearer ${accessToken}`,
            };
            
            // Build URL with isDownload flag
            const url = `menu-group?isDownload=true`;
            
            const response = await axiosInstance.get(url, { 
                headers,
                responseType: 'arraybuffer' // Use arraybuffer for better compatibility
            });
            
            // Check content type
            const contentType = response.headers['content-type'] || '';
            
            // If response is JSON (error case), parse it
            if (contentType.includes('application/json')) {
                const decoder = new TextDecoder('utf-8');
                const text = decoder.decode(new Uint8Array(response.data));
                const errorData = JSON.parse(text);
                toast.error(errorData.error || errorData.message || "Failed to download menu groups");
                setDownloadLoading(false);
                return;
            }
            
            // Generate standardized filename with timestamp
            const date = new Date();
            const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`;
            
            // Create filename
            let filename = `List of Menu Groups`;
            
            // Determine file extension based on content type
            if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                filename += '.xlsx';
            } else if (contentType.includes('application/vnd.ms-excel')) {
                filename += '.xls';
            } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
                filename += '.csv';
            } else {
                // Default to xlsx
                filename += '.xlsx';
            }
            
            // Create blob with proper MIME type
            const blob = new Blob([response.data], { 
                type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Verify file is not empty
            if (blob.size === 0) {
                toast.error("Downloaded file is empty");
                setDownloadLoading(false);
                return;
            }
            
            // Create download link
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            }, 200);
            
            toast.success("Menu groups downloaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } catch (error) {
            console.error("Download error:", error);
            
            // Handle error responses
            if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
                try {
                    const decoder = new TextDecoder('utf-8');
                    const text = decoder.decode(new Uint8Array(error.response.data));
                    const errorData = JSON.parse(text);
                    toast.error(errorData.error || errorData.message || "Failed to download menu groups");
                } catch {
                    toast.error("Failed to download menu groups. The server returned an unexpected response.");
                }
            } else if (error.response?.data?.error) {
                toast.error(error.response.data.error);
            } else {
                toast.error("Failed to download menu groups. Please try again.");
            }
        } finally {
            setDownloadLoading(false);
        }
    };
 
    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setErrors({}); // reset previous errors
        setInputData({
            groupName: '',
            description: ''
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async(e) => {
        e.preventDefault();

        setErrors({}); // reset previous errors

        const newErrors = {};

        if (!inputData.groupName.trim()) {
            newErrors.groupName = "Group name is required.";
        }

        const wordCount = inputData.description.trim().split(/\s+/).length;
        if (!inputData.description.trim()) {
            newErrors.description = "Description is required.";
        } else if (wordCount < 4) {
            newErrors.description = "Description must be at least 4 words.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axiosInstance.post("menu-group", inputData, { headers });
            console.log("Response of new group added :", response);


            if (response?.data?.status === true) {

                const menuGroupId = response?.data?.data?.data?._id;
                console.log("Menu Group:", menuGroupId);

                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });

                // Update productList with the new menuGroupId
                const updatedProductList = productList.map(product => ({
                    ...product,
                    group: menuGroupId
                }));
                setProductList(updatedProductList);

                // Prepare the request body for the second API call
                const reqBody = updatedProductList.map(product => ({
                    product: product._id, // or whatever your product ID field is called
                    group: menuGroupId,
                    mrpPrice: product.mrp,
                    offerPrice: product.offerPrice
                }));

                // Second API call to add multiple products with pricing
                const pricingResponse = await axiosInstance.post(
                    "/menu-product-pricing/addMultileProductsWithOutFile", 
                    reqBody, 
                    { headers }
                );

                console.log("Pricing response:", pricingResponse);

                if (pricingResponse?.data?.status === true) {
                    toast.success("Products added to group successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }

                getMenuGroup();
                setOpenAddModal(false);
                setInputData({
                    groupName: '',
                    description: ''
                })
            }
        } catch (error) {
            if (error?.response) {
                console.log("Error p;", error);
                
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if ( error.response?.status === 409 ) {
                    errorMessage = error?.response?.data?.error;
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }else if(error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.error
                }
        
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    }

    const handleOpenEditModal = (data) => {
        console.log("Edited Data :", data);
        
        setEditData({
            _id: data?._id,
            groupName: data?.groupName,
            description: data?.description,
            isDefaultGroup: data?.isDefaultGroup
        });
        setOpenEditModal(true);
    }

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData((prevData) => ({
            ...prevData,
            [name] : value
        }))
    }

    const handleEditSubmit = async(e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const response = await axiosInstance.put("menu-group", editData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getMenuGroup();
                setOpenEditModal(false);
            }
        } catch (error) {
            console.log("Error Wile Updateing :", error);
            
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
        
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    }

    const handleOpenDeleteModal = (data) => {
        console.log("Deleted Data :", data);
        setMenuGroupId(data?._id);
        if (data?.isDefaultGroup) {
            toast.error("Cannot Delete Default Menu Group", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } else {
            setOpenDeleteModal(true);
        }
        // setOpenDeleteModal(true);
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    }

    const handleDeleteGroup = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
                const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // const data = {
            //     _id: menuGroupId,
            // };
            const response = await axiosInstance.delete(`menu-group?_id=${menuGroupId}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getMenuGroup();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
    
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    }

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    }

    const handlePageChange = (page) => {
        setPage(page);
    };
  
    const handleRowsPerPageChange = (rowsPerPage) => {
        setPage(1);
        setRowsPerPage(rowsPerPage);
    };
  
    // Function to get paginated data
    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        
        const endIndex = startIndex + rowsPerPage;
  
        return filteredData?.slice(startIndex, endIndex);
    };

    useEffect(() => {
        getMenuGroup();
        getProductsList();
    }, []);

    useEffect(() => {
        const result = groupList?.filter((item) => {
            return item.groupName.toLowerCase().match(searchText.toLocaleLowerCase());
        });
        setFilteredData(result);
    }, [searchText]);


    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">MENU GROUP MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className='mb-3 justify-content-between'>
                        <Col lg="8">
                            <div className="d-flex gap-4
                            ">
                                <div className="input-group w-50">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={searchText}
                                        onChange={handleSearchChange}
                                        placeholder="Search by group name..."
                                    />
                                    <button className="btn btn-primary" type="button">
                                        <i className="ri-search-line"></i> {/* Search Icon */}
                                    </button>
                                </div>
                                {(menuAccess.includes("MenuGroup:get") || email === "contact@xpansecafe.com") && (
                                    <Button
                                        variant="success"
                                        onClick={handleDownload}
                                        disabled={downloadLoading}
                                        className="d-flex align-items-center justify-content-center gap-2 fw-semibold w-25"
                                    >
                                        {downloadLoading ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : (
                                            <Download fontWeight="bold" size={16} />
                                        )}
                                        {downloadLoading ? " Downloading..." : " Download"}
                                    </Button>
                                )}
                            </div>
                        </Col>
                        {(menuAccess.includes("MenuGroup:add") || email === "contact@xpansecafe.com") && (
                            <Col lg="3" className='text-end'>
                                <Button
                                variant="primary"
                                onClick={handleOpenAddModal}
                                className="fw-semibold"
                                >
                                <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                                    Add New Menu Group
                                </Button>
                            </Col>
                        )}
                    </Row>

                    {/* List of addon groups */}
                    <Row>
                        <Col lg="12">
                            {(menuAccess.includes("MenuGroup:get") || email === "contact@xpansecafe.com") && (
                                <ReusableTable 
                                    columns={columns}
                                    data={getPaginatedData()}
                                    currentPage={page}
                                    recordsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                    rowKey="serialNumber"
                                    loading={isLoading}
                                />
                            )}
                        </Col>
                    </Row>

                    { openAddModal ? (
                        <Modal show={openAddModal} onHide={handleCloseAddModal} size='md' centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Add New Menu Group</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body>
                                    <Form.Group className='mb-2' controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>
                                            Name of the Group <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            name="groupName"
                                            className="form-control"
                                            value={inputData?.groupName}
                                            type="text"
                                            placeholder="Enter Group Name"
                                            onChange={handleChange}
                                            isInvalid={!!errors.groupName}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.groupName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label className="fw-semibold">
                                            Description <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            type="text"
                                            placeholder="Description"
                                            name="description"
                                            value={inputData?.description}
                                            onChange={handleChange}
                                            isInvalid={!!errors.description}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.description}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type='submit'>
                                        {
                                            isAddBtnLoading ?
                                            <Spinner 
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> : "Add New Group"
                                        }
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null }

                    {openEditModal ? (
                        <Modal show={openEditModal} onHide={handleCloseEditModal} size='md' centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Update Menu Group</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body>
                                    <Form.Group className='mb-2' controlId="formCategoryName">
                                        <Form.Label className='fw-semibold'>
                                            Name of the Group <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            name="groupName"
                                            className="form-control"
                                            value={editData?.groupName}
                                            type="text"
                                            placeholder="Enter Group Name"
                                            onChange={handleEditChange}
                                            // isInvalid={!!errors.groupName}
                                        />
                                        {/* <Form.Control.Feedback type="invalid">
                                            {errors.groupName}
                                        </Form.Control.Feedback> */}
                                    </Form.Group>
                                    {/* <Form.Group className="mb-2">
                                        <Form.Label className="fw-semibold">
                                            Select Default <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="isDefaultGroup"
                                            value={editData.isDefaultGroup}
                                            onChange={handleEditChange}
                                        >
                                            <option>Select Value</option>
                                            <option value="true">YES</option>
                                            <option value="false">NO</option>
                                        </Form.Select>
                                    </Form.Group> */}
                                    <Form.Group className='mb-2'>
                                        <Form.Label className="fw-semibold">
                                            Description <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            type="text"
                                            placeholder="Description"
                                            name="description"
                                            value={editData?.description}
                                            onChange={handleEditChange}
                                            // isInvalid={!!errors.description}
                                        />
                                        {/* <Form.Control.Feedback type="invalid">
                                            {errors.description}
                                        </Form.Control.Feedback> */}
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type='submit'>
                                        {
                                            isEditBtnLoading ?
                                            <Spinner 
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> : "Update Group"
                                        }
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null }

                    {/* <---------------- Delete Role Modal ------------> */}
                    { openDeleteModal ? (
                        <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                            <Modal.Header closeButton>
                                <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this Group? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDeleteGroup}>
                                    { isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete Group"                                
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null }
                </div>
            </div>
        </React.Fragment>
    )
}

export default MenuGroup